<script>
import MvPage from './MvPage'
import MvDefaultRow from './MvDefaultRow'
import MvMedRow from './MvMedRow'
import MvAmount from './MvAmount'
import MvMsgCount from './MvMsgCount'
import MvPageBottomProgress from './MvPageBottomProgress'
export default {
  components: {
    MvMedRow, MvDefaultRow, MvPage, MvMsgCount, MvPageBottomProgress, MvAmount
  }
}
</script>
